import { computed, type Ref } from 'vue'

import { useAuth } from '@common/auth-layer/composables/useAuth'
import { useChats } from '@communities/chats-layer/composables/useChats'

export function useCPChatShell(
  route: { path: string; name?: string | null | undefined },
  chatContainerRef: Ref<{ handleChatClick: () => Promise<void> } | null>
) {
  const authStore = useAuth().store
  const chats = useChats()

  // Chat is available app-wide for authenticated users (top-bar button on every
  // route, not only communities), matching gokollab. The full-page conversations
  // route still excludes the floating container via `isConversationsRoute` below.
  const showChatButton = computed(() => authStore.isLoggedIn)
  const isConversationsRoute = computed(() => route.path.includes('/conversations'))
  const shouldMountChatContainer = computed(() => showChatButton.value && !isConversationsRoute.value)

  const unreadConversationsQuery = chats.fetchUnreadCount(computed(() => authStore.isLoggedIn && showChatButton.value))
  const chatUnreadCount = computed(() => unreadConversationsQuery.data.value || 0)

  const handleTopBarChatClick = async () => {
    await chatContainerRef.value?.handleChatClick?.()
  }

  return {
    chatUnreadCount,
    handleTopBarChatClick,
    showChatButton,
    shouldMountChatContainer,
  }
}
